import React from 'react';
import {
  Box,
  Card,
  CardContent,
  Typography,
  Button,
  Alert,
} from '@mui/joy';
import { useNavigate } from 'react-router-dom';
import { CheckCircle as CheckCircleIcon } from '@phosphor-icons/react';

export const AffiliateApplicationSuccessPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Box sx={{ p: 3, maxWidth: 600, mx: 'auto', mt: 8 }}>
      <Card>
        <CardContent sx={{ textAlign: 'center' }}>
          <CheckCircleIcon size={80} color="var(--joy-palette-success-500)" style={{ marginBottom: 24 }} />
          
          <Typography level="h2" sx={{ mb: 2 }}>
            Application Submitted Successfully!
          </Typography>
          
          <Typography level="body-lg" sx={{ mb: 4, color: 'text.secondary' }}>
            Thank you for applying to the ApexOS Affiliate Program
          </Typography>

          <Alert color="primary" sx={{ mb: 4, textAlign: 'left' }}>
            <Typography level="body-md">
              <strong>What happens next?</strong>
            </Typography>
            <ul style={{ marginTop: '8px', marginBottom: 0, paddingLeft: '20px' }}>
              <li>Our team will review your application within 2-3 business days</li>
              <li>You'll receive an email confirmation at the address provided</li>
              <li>Once approved, you'll get access to your affiliate dashboard</li>
              <li>You can start earning 20% commission on every successful referral</li>
            </ul>
          </Alert>

          <Card variant="soft" sx={{ mb: 4 }}>
            <CardContent>
              <Typography level="title-md" sx={{ mb: 1 }}>
                📧 Need Help?
              </Typography>
              <Typography level="body-sm">
                If you have any questions about your application or the affiliate program, 
                please contact us at{' '}
                <a href="mailto:affiliates@apexos.io">affiliates@apexos.io</a>
              </Typography>
            </CardContent>
          </Card>

          <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center' }}>
            <Button
              variant="solid"
              color="primary"
              onClick={() => navigate('/dashboard')}
            >
              Go to Dashboard
            </Button>
            <Button
              variant="outlined"
              color="primary"
              onClick={() => navigate('/login')}
            >
              Return to Login
            </Button>
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
};